module.exports = {
      id: "tree-usage",
      viewBox: "0 0 218 334",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#tree-usage",
      toString: function () {
        return this.url;
      }
    }